import axios from "axios";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { env } from "../../env";
import Swal from "sweetalert2";

const DeactivatePopUp = ({customerId, deactivateReasonList, sendDeactivePopUpDataFromChild}) => {
    const { t } = useTranslation();

    const [showDropDown, setShowDropDown] = useState(false);

    const [reason, setReason] = useState("");
    const [reasonId, setReasonId] = useState(0);
    const [comment, setComment] = useState("");

    const hangleModalClose = (e) => {
        e.preventDefault();
        sendDeactivePopUpDataFromChild('normal');
    };
    const handleDropDown = (e, value) => {
        e.preventDefault();
        setShowDropDown(false);
        setReason(value.Title);
        setReasonId(value.ID)
    };
    const handleCommentChange = (e) => {
        e.preventDefault();
        setComment(e.target.value);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        Swal.fire({
            title: `${ t("are you sure")}?`,
            text: `${ t("you want to deactivate this customer")}!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `${ t("yes")}!`,
            cancelButtonText: `${ t("cancel")}!`
        }).then((result) => {
            if (result.isConfirmed) { 
                const baseUrl = env.REACT_APP_API_URL;
                const token = localStorage.getItem('token');
                const requestData = {
                    "Deactivation_Reason": reasonId,
                    "CustomerId": customerId,
                    "Comment": comment,
                }

                axios.post(baseUrl+"/api/Customer/SetCustomerDeactivation", {requestData}, {
                    headers : {
                        "Accept" : "Application/json",
                        "Content-Type" : "Application/json",
                        "Authorization" : `Bearer ${token}`
                    }
                }).then((response) => {
                    if(response.data.success === "1") {
                        sendDeactivePopUpDataFromChild('updated');
                    }
                }).catch((error) => {
                    console.log(error);
                    if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                        localStorage.removeItem("token");
                        localStorage.removeItem("userInfo");
                        window.location.reload();
                    }
                });
            }
        });

    };

    return (
        <form onSubmit={(e) => handleSubmit(e)}>
            <div className="fixed z-50 overflow-y-auto top-0 w-full left-0 h-full">
                <div className="flex items-center justify-center min-height-100vh pt-4 px-4 pb-20 text-center sm:block sm:p-0 h-full">
                    <div className="fixed inset-0 transition-opacity">
                        <div className="absolute inset-0 bg-gray-900 opacity-75" />
                    </div>
                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
                    <div className="inline-block align-center bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-lg w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                        <div className="bg-white py-4 px-4 sm:px-8 sm:py-8 space-y-2 sm:space-y-3">
                            <div className="flex justify-between">
                                <div className="font-semibold sm:text-lg first-letter:capitalize">{ t('are you sure to deactivate the customer')} ?</div>
                                <div className="cursor-pointer" onClick={(e) => hangleModalClose(e)}>
                                    <img src="../../../assets/icons/modal-cross.svg" alt="cross" />
                                </div>
                            </div>
                            <div className="sm:flex sm:items-center text-sm space-y-1 sm:space-y-0">
                                <div className="sm:border sm:border-y-2 sm:border-l-2 sm:border-background-normal sm:p-2 sm:bg-blue-light capitalize sm:rounded-l-lg sm:w-40 sm:text-center font-medium">{ t('reason')}</div>
                                <div className="relative border border-l-2 sm:border-l-0 border-y-2 border-r-2 border-background-normal p-2 w-full rounded-l-lg sm:rounded-l-none rounded-r-lg">
                                    <button type="button" onClick={(e) => setShowDropDown(!showDropDown)} className=" text-gray-dark w-full justify-between font-normal inline-flex items-center">
                                        <span className={(reason ? "text-black" : "text-gray-dark") + " first-letter:capitalize mr-1 text-sm"}>{reason ? reason : t('select the reason')}</span>
                                        <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                    </button>
                                    {
                                        showDropDown
                                        ? 
                                            <ul className="absolute z-30 bg-white shadow-md rounded-md top-10 right-0 w-full">
                                                { deactivateReasonList.length > 0 ?
                                                    deactivateReasonList.map((reason, index) => (
                                                        <li key={index} onClick={(e) => handleDropDown((e), reason)} className="bg-white hover:bg-action-hover py-1 sm:py-2 px-4 block whitespace-no-wrap cursor-pointer first-letter:capitalize text-sm">{ t(reason.Title.toLowerCase())}</li>
                                                    ))
                                                    : null
                                                }
                                            </ul>                            
                                        : null
                                    }
                                </div>
                            </div>
                            <div>
                                <textarea rows={5} cols={10} className="border-2 border-background-normal bg-white p-2 w-full focus:outline-none placeholder:capitalize rounded-lg" placeholder={ t("write comments here...")} onChange={(e) => handleCommentChange(e)} />
                            </div>
                            <div className="flex justify-end items-center space-x-4 mt-4 sm:mt-0">
                                <button onClick={(e) => hangleModalClose(e)} type="button" className="text-center px-2 sm:px-4 text-xs font-medium sm:text-base py-2 text-blue-normal bg-white border border-blue-normal rounded-lg tracking-wide capitalize">{ t('cancel') }</button>
                                <button type={reason ? "submit" : "button"} className={((reason && comment) ? "bg-blue-normal border border-blue-normal " : "text-white border-blue-disable cursor-not-allowed bg-blue-disable") + " text-center px-2 sm:px-4 text-xs font-medium sm:text-base py-2 text-white rounded-lg tracking-wide capitalize"}>{ t('deactivate') }</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default DeactivatePopUp;